//verificar carrito para los cupones
class CartWatcher {
  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges();
    });
  }

  async fetchCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  storeCart(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
  }

 storedCart() {
    return JSON.parse(localStorage.getItem('cart')) || { items: [] };
  }

 findCartChanges(oldCart, newCart) {
    const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
    let result = {
      added: onlyInLeft(newCart.items, oldCart.items),
      removed: onlyInLeft(oldCart.items, newCart.items),
    };

    oldCart.items.forEach(oi => {
      const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
      if (!ni) return;
      let quantity = ni.quantity - oi.quantity;
      let item = { ...ni };
      item.quantity = Math.abs(quantity);
      quantity > 0
        ? result.added.push(item)
        : result.removed.push(item)
    });

    return result;
  }

  async emitCartChanges() {
    const newCart = await this.fetchCart();
    const oldCart = this.storedCart();
    const changes = this.findCartChanges(oldCart, newCart);

    // Obtener datos de descuentos
    const totalDiscount = newCart.total_discount;
    const discountApplications = newCart.cart_level_discount_applications;

    const event = new CustomEvent("cart_changed", {
      detail: {
        ...changes,
        totalDiscount,
        discountApplications,
        newCart
      }
    });
    window.dispatchEvent(event);

    this.storeCart(newCart);
  }

 observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.emitCartChanges();
        }
      });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
  }
}
const myCartWatcher = new CartWatcher;
myCartWatcher.init();
window.addEventListener("cart_changed", e => console.log(e));




if (window.location.pathname.includes('/products/')) {
  const mmenuItems = document.querySelectorAll('.m-sub-menu__item');
  const breadcrumbCollectionNode = document.querySelector('.breadcrumbCollection');
  const prodCollection = breadcrumbCollectionNode ? breadcrumbCollectionNode.textContent.trim() : '';
  //console.log(prodCollection);
  const breadcrumbCollection = document.querySelector('.breadcrumbCollection');
  const separator = document.querySelector('.m-breadcrumb--separator');
  
  mmenuItems.forEach((elem) => {
    const text = elem.textContent.trim();
    if (text === prodCollection) {
      const ancestor = elem.closest(".m-menu__item");
      const ancestorLink = ancestor.querySelector(".m-menu__link--main");
      const ancestorText = ancestor.querySelector('.m-menu__link').textContent.trim();
      const newLink = document.createElement('a');
      newLink.textContent = ancestorText;
      newLink.href =`${ancestorLink.href}` ;
      newLink.classList.add('m-breadcrumb--item');

      const newSeparator = document.createElement('span');
      newSeparator.classList.add('m-breadcrumb--separator');
      newSeparator.innerHTML = `<svg class="m-svg-icon--small m-rlt-reverse-x" fill="currentColor" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"></path></svg>`;
      
      separator.insertAdjacentElement("beforebegin", newSeparator);
      separator.insertAdjacentElement("beforebegin", newLink);
      /*addSeparator.insertAdjacentElement("beforebegin", ancestorText);*/
    }
  });
}

window.listen_variant_custom = function (variant) {
  let variant_id = variant.id;
  let all_items_dates = document.querySelectorAll('.js-delivery-date');
  let found = false;

  all_items_dates.forEach(item => {
    if (item.id == variant_id) {
      item.removeAttribute('hidden');
      found = true;
    } else {
      item.setAttribute('hidden', true);
    }
  });

  // Si no se encontró el ID del variant, mostramos el elemento con id "default_date"
  if (!found) {
    let default_item = document.querySelector('#default_date.js-delivery-date');
    if (default_item) {
      default_item.removeAttribute('hidden');
    }
  }
};
document.addEventListener("variant:changed", function(event) {
   // console.log("thomy Variant changed:", event.detail.variant);
    window.listen_variant_custom(event.detail.variant);
});

/* dimensiones selection */
let dimensiones = document.querySelector('.main-product__block .m-product-infodrawer.dimensiones');
if(dimensiones){
  dimensiones.addEventListener("click", function chooseDimension(){
    setTimeout(() => {
    document.querySelectorAll('.contenedor-dimensiones').forEach(div => {
      div.classList.add('hide');
      if (div.dataset.variantid == document.querySelector('form input[name=id]').value) {
        console.log(div.dataset.variantid);
        div.classList.remove('hide');
      }
    });
    }, 100);  
  });
}
/* Econder logo en Unsuscribe Style */
let logoText = document.querySelector('main .shopify-email-marketing-confirmation__container h1');
if(logoText){
 logoText.style.display = "none"; 
}
const img = document.createElement('img');
img.src = 'https://cdn.shopify.com/s/files/1/0921/4174/8562/files/Logo2025_ATYCOshowroonBLACK.svg?3443';
img.alt = 'Logo';
img.width = 238;
img.style.margin = '0 0 1rem';
let logoTextContainer = document.querySelector('main .shopify-email-marketing-confirmation__container');
if(logoTextContainer){
  logoTextContainer.style.padding = "5rem 0";
  logoTextContainer.insertBefore(img, logoTextContainer.firstChild);
}
